import { getPermissionOptions } from "../../../utils/userConfig";
import { TrashCanIcon } from "../../core/customIcons";

export const getDetailViewConfig = async (data) => {
  // Assignable roles must reflect the CURRENT admin's authority, not a hardcoded "responder"
  // (which limited every actor — including super-admins — to Responder/School Admin). GH #130.
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  let permissionOptions = await getPermissionOptions(currentUser.permission);
  let permissionDisabled = false;
  if (data.permission === "disclosureAdmin") {
    permissionDisabled = true;
  } else {
    permissionOptions = await permissionOptions.filter((option) => {
      return option.value !== "disclosureAdmin";
    });
  }

  return {
    titleConfig: {
      breadcrumbs: false,
      field: "{firstName} {lastName}",
      mainAction: {
        type: "text",
        text: "Delete This User",
        field: "delete",
        textColor: "warning.main",
        textStyles: ["underline"],
        preIcon: <TrashCanIcon />,
        modalConfig: {
          delete: {
            title: "Delete User",
            type: "text",
            message:
              "Are you sure you want to delete {data.firstName} {data.lastName} User?",
            submitLabel: "Delete",
            cancelLabel: "Cancel",
            submitColor: "red",
            cancelColor: "blue",
            submitType: "delete",
          },
        },
      },
    },
    title: "users",
    type: "users",
    cards: [
      {
        column: 1,
        title: "Personal Information",
        bodyType: "form",
        fields: [
          {
            field: "firstName",
            headerName: "First Name",
            cellType: "text",
            required: true,
            type: "text",
            dataType: "string",
          },
          {
            field: "lastName",
            headerName: "Last Name",
            cellType: "text",
            required: true,
            type: "text",
            dataType: "string",
          },
          {
            field: "phone",
            headerName: "Phone",
            cellType: "text",
            required: true,
            type: "text",
            dataType: "phone",
          },
        ],
      },
      {
        column: 2,
        title: "Account",
        bodyType: "form",
        fields: [
          {
            field: "email",
            headerName: "Email",
            cellType: "text",
            disabled: true,
            required: true,
            type: "text",
            dataType: "email",
          },
          {
            field: "permission",
            headerName: "Role",
            disabled: permissionDisabled,
            required: true,
            type: "select",
            dataType: "string",
            options: permissionOptions,
          },
          {
            field: "district",
            labelField: "districtName",
            headerName: "District",
            cellType: "text",
            disabled: true,
            required: true,
            type: "select",
            options: [{label: data.districtName, value: data.district}],
            dataType: "string",
            requires: {
              permission: {
                requiresValues: ["districtAdmin", "schoolAdmin", "responder"],
              },
            },
          },
          {
            field: "school",
            labelField: "schoolName",
            headerName: "School",
            cellType: "text",
            required: true,
            type: "apiSelect",
            dataType: "string",
            apiConfig: {
              apiBody: {filters: [{ key: "district", value: data.district, expression: "=" }]},
              dataType: "schools",
              label: "",
            },
            requires: {
              permission: {
                requiresValues: ["schoolAdmin", "responder"],
              }
            },
          },
        ],
      },
      {
        column: 1,
        title: "Personal Time Off",
        bodyType: "table",
        apiType: "paidTimeOffs",
        apiBody: {
          userId: data.id,
        },
        columns: [
          {
            name: "Start Date",
          },
          {
            name: "End Date",
          },
          {
            name: "Count",
          },
        ],
      },
    ],
  };
};
